import { useCallback } from 'react';
import {
  type EdgeChange ,
  type Node,
  type Edge,
  applyEdgeChanges,
} from 'reactflow';

interface UseEdgesChangeProps {
  nodes: Node[];
  edges: Edge[];
  setEdges: React.Dispatch<React.SetStateAction<Edge[]>>;
}

export const useEdgesChange = ({ nodes, edges, setEdges }: UseEdgesChangeProps) => {
  const onEdgesChange = useCallback((changes: EdgeChange[]) => {
    const parsedChanges = changes.reduce((res: EdgeChange[], change) => {
      let validChange = true;

      if (change.type === 'remove') {
        validChange = false;
      }

      if (validChange) {
        res.push(change);
      }
      return res;
    }, []);

    setEdges((eds) => applyEdgeChanges(parsedChanges, eds));
  }, [edges, setEdges, nodes]);

  return { onEdgesChange };
}
